import React from "react";
//outsource
import { Input, Form } from "antd";

//components

//
const { TextArea } = Input;

const ServiceDescription = () => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="description" label="Description" rules={[]}>
      <TextArea rows={3} placeholder="Description" />
    </Form.Item>
  );
};

export default ServiceDescription;
